import type { AppUser, Department as StaffDepartment } from "@/features/auth/types";
import {
  KPI_DEFS,
  LOG_KPI_IDS,
  sortKpisForDisplay,
  type Department,
  type KpiDef,
} from "@/features/kpi/definitions";

export { LOG_KPI_IDS };

/**
 * Q8 map kept for when management is ready to widen KPIs. Owner 2026-08-14:
 * only portal admins (Komil, Zafar, admin) see KPIs until they say otherwise.
 */
export const STAFF_KPI_DEPARTMENTS: Record<StaffDepartment, Department[]> = {
  dispatch: ["company", "tank-dispatch", "dryvan-dispatch", "sales"],
  maintenance: ["fleet"],
  safety: ["safety", "fmcsa"],
  accounting: ["accounting"],
  hr: [],
};

/** Weekly ops review subset (Q9 default): dispatch + fleet + company-wide. */
export const WEEKLY_OPS_DEPARTMENTS: Department[] = [
  "company",
  "tank-dispatch",
  "dryvan-dispatch",
  "fleet",
];

export function kpiDepartmentsForStaff(
  user: Pick<AppUser, "role" | "staffLevel" | "department"> | null | undefined,
): Department[] | "all" {
  if (user?.role !== "internal") return [];
  if (user.staffLevel === "admin") return "all";
  return [];
}

export function canViewKpis(
  user: Pick<AppUser, "role" | "staffLevel" | "department"> | null | undefined,
): boolean {
  const sections = kpiDepartmentsForStaff(user);
  return sections === "all" || sections.length > 0;
}

export function canCollectKpis(
  user: Pick<AppUser, "role" | "staffLevel"> | null | undefined,
): boolean {
  return user?.role === "internal" && user.staffLevel === "admin";
}

export function canAccessKpiDepartment(
  user: Pick<AppUser, "role" | "staffLevel" | "department"> | null | undefined,
  department: Department,
): boolean {
  const sections = kpiDepartmentsForStaff(user);
  return sections === "all" || sections.includes(department);
}

export function visibleKpiDefs(
  user: Pick<AppUser, "role" | "staffLevel" | "department"> | null | undefined,
  defs: KpiDef[] = KPI_DEFS,
): KpiDef[] {
  const sections = kpiDepartmentsForStaff(user);
  const scoped =
    sections === "all" ? defs : defs.filter((def) => sections.includes(def.department));
  return sortKpisForDisplay(scoped);
}

export function isWeeklyOpsKpi(def: KpiDef): boolean {
  return WEEKLY_OPS_DEPARTMENTS.includes(def.department);
}
